import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@app/store/store';
import { ReactNode } from 'react';

interface PublicRouteProps {
  children: ReactNode;
}

const PublicRoute = ({ children }: PublicRouteProps) => {
  const isLoggedIn = useAppSelector((state) => state.auth.currentUser);
  
  console.log('PublicRoute:', { isLoggedIn: !!isLoggedIn });
  
  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

export default PublicRoute;